/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';
import throttle from 'lodash/throttle';
import NewMenuModal from '../../ui/NewMenuModal';
import NewSearch from '../../ui/NewSearch';
import { DARK_THEME } from '../../ui/Search/constants';
import { NAV } from '../../../utils/constants';
import { colorsPalette } from '../../../styles/colors';
import NewWaysToWork from './NewWaysToWork';
import NewMyAccount from './NewMyAccount';
import { Container, Row } from '../../../styles/Grid';
import NewTopLocationsMenu from './NewTopLocationMenu';
import { NavConsumer, navbar_finite_state } from '../../../contexts/NavContext';
import Nav from './NewNav';

import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  navCss,
  navContainerCss,
  containerModalCss,
  modalRowSearchCss,
  rowModalCss,
  modalCss,
  navSticky,
  CustContainer,
  leftSideCloseBtn,
  rightSideCloseBtn,
} from './index.styles';
import './style.css';
import { Icon } from '../../ui/Icon';

const menuToRender = {
  [navbar_finite_state.INITIAL]: () => {},
  [navbar_finite_state.WAYS_TO_WORK]: (fields, rendering, openModal) => (
    <NewWaysToWork fields={fields} openModal={openModal} />
  ),
  [navbar_finite_state.MY_ACCOUNT]: fields => <NewMyAccount fields={fields} />,
  [navbar_finite_state.CONTACT]: (fields, rendering, openModal) => (
    <NewWaysToWork
      fields={fields}
      showHelpAndSupport={true}
      openModal={openModal}
    />
    // <Contact fields={fields} rendering={rendering} />
  ),
  [navbar_finite_state.SEARCH]: fields => {
    const { NavigationItems, RichFiltering } = fields;
    const richFiltering = get(RichFiltering, 'value', false);
    return (
      <NewSearch
        richFiltering={richFiltering}
        // workspaceOptions={NavigationItems.value}
        hasRow={false}
        theme={DARK_THEME}
        replaceSearchButtonWithIcon
        parent={NAV}
      />
    );
  },
  [navbar_finite_state.SEARCH_NAV]: fields => {
    const { NavigationItems, RichFiltering } = fields;
    const richFiltering = get(RichFiltering, 'value', false);

    // console.log('NavigationItems >> ', NavigationItems);
    return (
      <NewSearch
        richFiltering={richFiltering}
        // workspaceOptions={NavigationItems.value}
        hasRow={false}
        theme={DARK_THEME}
        replaceSearchButtonWithIcon
        parent={NAV}
      />
    );
  },
  [navbar_finite_state.LOCATION]: fields => {
    // const { NavigationItems, RichFiltering } = fields;
    const SeoList = get(fields, 'SEO_LIST.value', {});
    // const richFiltering = get(RichFiltering, 'value', false);
    return (
      <NewTopLocationsMenu SeoList={SeoList} parent={NAV} isFromNav={true} />
    );
  },
};

const isBrowser = () => typeof window !== 'undefined';

export class NavigationV2 extends SafePureComponent {
  state = {
    isModalOpen: false,
    clickedItem: navbar_finite_state.INITIAL,
    windowWidth: 0,
    isSticky: false,
    stickyTop: 0,
  };

  onScrollHandler = () => {
    let stateObj = this.state;
    const fields = this.props.fields;
    if (fields.StickyBarEnabled.value) {
      const triggerBottom = this.stickyTriggerEl.getBoundingClientRect().top;
      // stateObj['isSticky'] = triggerBottom <= 0;
      this.setState({ isSticky: triggerBottom <= 0 });
    }

    let rootEle = document.querySelector('#root');
    let isFeatureHeroPage =
      document.querySelector('section.show-blur-nav') !== null;
    let covidBannerEle = document.querySelector('#covid19-banner');
    let topOffsetForScroll = 0;
    if (covidBannerEle !== null) {
      let covidBannerComputeStyle = window.getComputedStyle(covidBannerEle);
      topOffsetForScroll = parseInt(covidBannerComputeStyle.height, 10);
    }

    let stickyTop =
      !stateObj.isSticky &&
      isFeatureHeroPage &&
      window.scrollY < topOffsetForScroll
        ? rootEle.offsetTop
        : 0;
    if (
      document
        .querySelector('body')
        .classList.contains('ReactModal__Body--open')
    ) {
      stickyTop = 0;
    }
    // ReactModal__Body--open

    this.setState({ stickyTop: stickyTop });
  };

  throttledOnScrollHandler = throttle(this.onScrollHandler, 10);

  componentDidMount() {
    this.updateDimensions();
    isBrowser() && window.addEventListener('resize', this.updateDimensions);

    // this.stickyTriggerEl = document.querySelector(stickyTriggerElSelector)[1];
    let allSectionEle = document.querySelectorAll('section');
    if (allSectionEle !== null && allSectionEle.length > 1) {
      if (allSectionEle[0] && allSectionEle[0].querySelector('a')) {
        let allAnchor = document
          .querySelectorAll('section')[0]
          .querySelectorAll('a');
        this.stickyTriggerEl = allAnchor[allAnchor.length - 1];
        console.log('zzy sticky nav anchor');
      } else if (allSectionEle[0] && allSectionEle[0].querySelector('button')) {
        let allButtons = document
          .querySelectorAll('section')[0]
          .querySelectorAll('button');
        this.stickyTriggerEl = allButtons[allButtons.length - 1];
        console.log(
          'zzy sticky nav button',
          allSectionEle[0].querySelectorAll('button'),
        );
      } else {
        this.stickyTriggerEl = allSectionEle[1];
        console.log('zzy sticky nav section');
      }
    }

    if (this.stickyTriggerEl) {
      console.log('zzy stickyTriggerEl', this.stickyTriggerEl);
      this.onScrollHandler();
      isBrowser() &&
        window.addEventListener('scroll', this.throttledOnScrollHandler);
    }
  }

  componentWillUnmount() {
    isBrowser() && window.removeEventListener('resize', this.updateDimensions);
    isBrowser() &&
      window.removeEventListener('scroll', this.throttledOnScrollHandler);
  }

  updateDimensions = () => {
    if (isBrowser()) {
      this.setState({ windowWidth: window.innerWidth });
    }
  };

  getModalContentStyle = clickedItem => {
    const { windowWidth } = this.state;

    let modalStyle = modalCss;

    if (
      clickedItem == navbar_finite_state.WAYS_TO_WORK ||
      clickedItem == navbar_finite_state.CONTACT
    ) {
      modalStyle = {
        ...modalStyle,
        // display: 'flex',
        height: '100%',
        background: 'rgba(255, 255, 255, 0.9)',
        width: '100%',
        maxWidth: '448px',
        outline: '0px',
        position: 'relative',
      };
    }
    if (clickedItem === navbar_finite_state.MY_ACCOUNT) {
      modalStyle = {
        ...modalStyle,
        // display: 'flex',
        height: '100%',
        background: 'rgba(255, 255, 255, 0.9)',
        width: '100%',
        maxWidth: '370px',
        outline: '0px',
      };
    }
    if (windowWidth <= 768) {
      modalStyle['width'] = '100%';
    }
    if (
      clickedItem === navbar_finite_state.SEARCH ||
      clickedItem === navbar_finite_state.SEARCH_NAV
    ) {
      modalStyle = {
        ...modalStyle,
        zIndex: 9,
        background: 'rgb(255 255 255 / 0.9)',
        height: '100%',
        width: '100%',
      };
    }
    if (clickedItem === navbar_finite_state.LOCATION) {
      modalStyle = {
        ...modalStyle,
        zIndex: 9,
        background: 'rgb(255 255 255)',
        height: '100%',
        overflow: 'auto',
        width: '100%',
      };
    }
    if (windowWidth <= 600) {
      modalStyle['width'] = '100%';
    }

    return modalStyle;
  };

  getModalClass(clickedItem) {
    let className = ['modal-content-area'];

    if (
      clickedItem !== navbar_finite_state.SEARCH &&
      clickedItem !== navbar_finite_state.SEARCH_NAV &&
      clickedItem !== navbar_finite_state.CONTACT
    ) {
      if (clickedItem === navbar_finite_state.MY_ACCOUNT) {
        className.push('my-animation-right');
      } else {
        className.push('my-animation-left');
      }
    }

    return className.join(' ');
  }

  getCloseModalText = clickedItem => {
    if (
      clickedItem == navbar_finite_state.WAYS_TO_WORK ||
      clickedItem == navbar_finite_state.CONTACT
    ) {
      return this.props.fields.NavObject.value.LeftMenu.CloseTriggerLabel;
    }
    if (clickedItem === navbar_finite_state.MY_ACCOUNT) {
      return this.props.fields.NavObject.value.RightMenu.CloseTriggerLabel;
    }
    if (clickedItem === navbar_finite_state.LOCATION) {
      return 'Back';
    }
    const { fields } = this.props;
    return fields.CloseText.value;
  };

  getCloseModal = (clickedItem, openModal, closeModal) => {
    if (
      [navbar_finite_state.SEARCH_NAV, navbar_finite_state.LOCATION].includes(
        clickedItem,
      )
    ) {
      openModal({
        target: {
          dataset: {
            id: navbar_finite_state.WAYS_TO_WORK,
          },
        },
      });
    } else {
      closeModal();
    }
  };

  safeRender() {
    const { fields} = this.props;
    const { rendering, sitecoreContext } = this.props;
    const language = get(sitecoreContext, 'route.itemLanguage', '')
      .replace(/sr-Latn-RS/i, "sr-rs").replace(/tg-Cyrl-TJ/i, "tg-tj").replace(/az-Latn-az/i, "az-az");

    const CallUsNumber = get(fields, 'CallUsNumber.value', '');
    const CallUsText = get(fields, 'CallUsText.value', '');

    const RightOpenTriggerLabel = get(
      fields,
      'NavObject.value.RightMenu.OpenTriggerLabel',
      '',
    );
    const LeftOpenTriggerLabel = get(
      fields,
      'NavObject.value.LeftMenu.OpenTriggerLabel',
      '',
    );

    const { isSticky, windowWidth, stickyTop } = this.state;

    let isFeatureHeroPage =
      document.querySelector('section.show-blur-nav') !== null;

    return (
      <NavConsumer>
        {({ isModalOpen, closeModal, openModal, clickedItem }) => (
          <div
            css={[
              navContainerCss,
              isSticky && navSticky(0),
              isFeatureHeroPage && !isSticky && navSticky(stickyTop),
            ]}
            className="navigation-v2"
          >
            <div className="bg-blur"></div>
            <React.Fragment>
              <Container css={{ height: '100%' }}>
                <nav className="navCss">
                  <Nav
                    isSticky={isSticky}
                    callusInfo={{
                      number: CallUsNumber,
                      text: CallUsText,
                    }}
                    clickedItem={clickedItem}
                    language={language}
                    membership={RightOpenTriggerLabel}
                    onClickItem={openModal}
                    waysToWorkText={LeftOpenTriggerLabel}
                  
                  />
                </nav>
              </Container>

              <NewMenuModal
                // className="modal-content-area"
                className={this.getModalClass(clickedItem)}
                overlayProp={
                  clickedItem === navbar_finite_state.MY_ACCOUNT
                    ? {
                        width: '100%',
                        justifyContent: 'flex-end',
                        display: 'flex',
                        background: 'none',
                        height: '100%',
                      }
                    : { width: '100%', background: 'none', height: '100%' }
                }
                contentProp={this.getModalContentStyle(clickedItem)}
                hideDefaultCloseButton
                contentBackground={colorsPalette.white}
                isOpen={isModalOpen}
                onRequestClose={closeModal}
              >
                <div
                  css={[CustContainer, containerModalCss]}
                  className="content-area"
                >
                  {clickedItem !== navbar_finite_state.LOCATION && (
                    <div css={[navCss]}>
                      {windowWidth > 600 ? (
                        <Nav
                          isSticky={isSticky}
                          callusInfo={{
                            number: CallUsNumber,
                            text: CallUsText,
                          }}
                          clickedItem={clickedItem}
                          closeModal={() => {
                            this.getCloseModal(
                              clickedItem,
                              openModal,
                              closeModal,
                            );
                          }}
                          isModalOpen={isModalOpen}
                          language={language}
                          membership={RightOpenTriggerLabel}
                          onClickItem={openModal}
                        
                          // closeText={closeButtonText}
                          closeText={this.getCloseModalText(clickedItem)}
                          closeIcon={
                            clickedItem === navbar_finite_state.LOCATION ? (
                              <Icon name="arrow-left" />
                            ) : (
                              <i className="icon-closer" />
                            )
                          }
                          waysToWorkText={LeftOpenTriggerLabel}
                        />
                      ) : (
                        <button
                          onClick={() => {
                            this.getCloseModal(
                              clickedItem,
                              openModal,
                              closeModal,
                            );
                          }}
                          data-id={navbar_finite_state.CLOSE}
                          css={[
                            leftSideCloseBtn,
                            (clickedItem === navbar_finite_state.SEARCH ||
                              clickedItem === navbar_finite_state.SEARCH_NAV ||
                              clickedItem === navbar_finite_state.MY_ACCOUNT) &&
                              rightSideCloseBtn,
                          ]}
                        >
                          <span>
                            <i className="icon-closer" />
                          </span>
                          <span className="translate-text-" css={[]}>
                            {this.getCloseModalText(clickedItem)}
                          </span>
                        </button>
                      )}
                    </div>
                  )}

                  <Row
                    className={
                      clickedItem === navbar_finite_state.WAYS_TO_WORK &&
                      'scrollsec'
                    }
                    css={[
                      (clickedItem === navbar_finite_state.SEARCH ||
                        clickedItem === navbar_finite_state.SEARCH_NAV) &&
                        modalRowSearchCss,
                      clickedItem === navbar_finite_state.CONTACT &&
                        rowModalCss,
                    ]}
                  >
                    {menuToRender[clickedItem](fields, rendering, openModal)}
                  </Row>
                </div>
              </NewMenuModal>
            </React.Fragment>
          </div>
        )}
      </NavConsumer>
    );
  }
}

NavigationV2.displayName = 'NavigationV2';

NavigationV2.defaultProps = {
  t: key => key,
};

export default withSitecoreContext()(NavigationV2);
